import { makeStyles } from "@material-ui/core/styles";

export const useStyles= makeStyles({
    root: {
        "& .MuiIconButton-label svg": {
            height: '15px',
            width: '15px'
        }
    }
});